import axios from 'axios';
import { push } from 'react-router-redux';
import * as actionTypes from './actionTypes';
import {
  JWTOKEN,
  STAFFID,
  STDBIDSESSION_ID,
  CATEGORY_ID,
  STATION_ID
} from './../constants';
import { errors } from './../../labels/labels.json';
import apiCall from './../app/apiCall.js';
import { apiUrl } from './../../settings/settings';

export const fetchStaffLoginRequest = () => ({
  type: actionTypes.FETCH_STAFF_LOGIN_REQUEST
});
export const fetchStaffLoginFailure = message => ({
  type: actionTypes.FETCH_STAFF_LOGIN_FAILURE,
  message
});
export const fetchStaffLoginSuccess = login => ({
  type: actionTypes.FETCH_STAFF_LOGIN_SUCCESS,
  login
});
export const fetchSuccess = adminuser => ({
  type: actionTypes.FETCH_SUCCESS,
  allstaffs
});
export const fetchFailure = message => ({
  type: actionTypes.FETCH_FAILURE,
  message
});
export function redirect(path) {
  return dispatch => {
    dispatch(push(path));
  };
}

export function fetchAllStaff() {
  return () => {
    const userRequestUrl = `employees/all-employees`;

    return apiCall(userRequestUrl);
  };
}
export function getUserInformation(staffId) {
  return () => {
    const userRequestUrl = `employees/${staffId}`;
    return apiCall(userRequestUrl);
  };
}

export function fetchStaffLogin(username, password) {
  return dispatch => {
    function getUserInformation(jwToken, staffId) {
      const userRequestUrl = `employees/${staffId}`;
      apiCall(userRequestUrl).then(data => {
        const user = data.data;
        sessionStorage.setItem(STDBIDSESSION_ID, user.standingBidSessionId || null);
        sessionStorage.setItem(
          CATEGORY_ID,
          user.currentCategory.categoryId || null
        );
        sessionStorage.setItem(
          STATION_ID,
          user.currentCategory.stationId || null
        );
        setTimeout(() => window.location.reload(), 500);
        dispatch(push('home'));
        return dispatch(fetchLoginSuccess({ jwToken, user }));
      });
    }
    dispatch(fetchStaffLoginRequest());
    return axios({
      method: 'post',
      url: `${apiUrl}/auth/login`,
      data: {
        username,
        password
      }
    })
      .then(response => {
        const jwToken = response.data;
        sessionStorage.setItem(JWTOKEN, JSON.stringify(jwToken));
        sessionStorage.setItem(STAFFID, username);
        getUserInformation(jwToken, username);
      })
      .catch(error => {
        let errorToDisplay = '';
        if (error.response) {
          errorToDisplay = errors.LOGIN_401;
        } else {
          errorToDisplay = errors.LOGIN_FAILURE;
        }
        dispatch(fetchLoginFailure(errorToDisplay));
      });
  };
}
